import { MENU_ZOEKWOORDEN, MENU_SUBONDERDELEN } from "@/constants/moduleInfo";

/* Voorstel 55 — zoekindex over het menu (hubs → pagina's → sub-onderdelen). Alleen lokaal, geen API. */
export const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[-_/]/g, " ");
const padVan = (to) => (to || "").split("?")[0].split("#")[0];

function levenshtein(a, b, max) {
  if (Math.abs(a.length - b.length) > max) return max + 1;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const cur = [i];
    let rijMin = i;
    for (let j = 1; j <= b.length; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      rijMin = Math.min(rijMin, cur[j]);
    }
    if (rijMin > max) return max + 1;
    prev = cur;
  }
  return prev[b.length];
}

/** Spellingtolerant: exact deel van de tekst, of een woord dat op afstand ≤1 (≥5 tekens) / ≤2 (≥8 tekens) ligt (ook als prefix). */
export function woordMatcht(term, tekst, woorden) {
  if (woorden.includes(term)) return 3;
  if (woorden.some((w) => w.startsWith(term))) return 2;
  if (term.length >= 5 && tekst.includes(term)) return 1;
  const max = term.length >= 8 ? 2 : term.length >= 5 ? 1 : 0;
  if (!max) return 0;
  for (const w of woorden) {
    if (levenshtein(term, w, max) <= max || (w.length > term.length && levenshtein(term, w.slice(0, term.length), max) <= max)) return 1;
  }
  return 0;
}

/** Bouwt de index uit de (rechten-gefilterde) hubs. */
export function bouwIndex(hubs) {
  const items = [];
  const perPad = {};
  (hubs || []).forEach((hub) => (hub.items || []).forEach((it) => {
    const pad = padVan(it.to);
    const extra = MENU_ZOEKWOORDEN[pad] || [];
    const tekst = norm([it.label, it.module, it.subgroup, hub.label, it.beschrijving, ...(it.keywords || []), ...extra].filter(Boolean).join(" "));
    const entry = { key: `p:${it.to}`, to: it.to, label: it.label, icon: it.icon, tid: it.tid, pad: `${hub.label} › ${it.subgroup || hub.label}`, hub: hub.label,
                    labelNorm: norm(it.label), tekst, woorden: [...new Set(tekst.split(/\s+/).filter((w) => w.length >= 3))], soort: "pagina" };
    items.push(entry);
    if (!perPad[pad]) perPad[pad] = entry;
  }));
  MENU_SUBONDERDELEN.forEach((s) => {
    const ouder = perPad[s.ouder];
    if (!ouder) return; // geen recht op de ouderpagina → ook het sub-onderdeel niet
    const tekst = norm([s.label, ouder.label, ouder.hub, ...(s.woorden || [])].join(" "));
    items.push({ key: `s:${s.to}`, to: s.to, label: `${ouder.label} › ${s.label}`, kort: s.label, icon: ouder.icon, tid: `${ouder.tid}-${norm(s.label).replace(/\s+/g, "-")}`,
                 pad: `${ouder.pad} › ${ouder.label}`, hub: ouder.hub, labelNorm: norm(s.label), tekst, woorden: [...new Set(tekst.split(/\s+/).filter((w) => w.length >= 3))], soort: "onderdeel" });
  });
  return items;
}

/** Zoekt in de index; max 10 treffers, gesorteerd op relevantie. */
export function zoek(index, q, max = 10) {
  const term = norm(q.trim());
  if (!term) return [];
  const termen = term.split(/\s+/).filter(Boolean);
  const uit = [];
  for (const it of index) {
    let score = 0;
    let alles = true;
    for (const t of termen) {
      const m = woordMatcht(t, it.tekst, it.woorden);
      if (!m) { alles = false; break; }
      score += m === 3 ? 30 : m === 2 ? 20 : 8;
      const labelWoorden = it.labelNorm.split(/\s+/);
      if (labelWoorden.some((w) => w.startsWith(t))) score += it.labelNorm.startsWith(t) ? 110 : 100;
      else if (it.labelNorm.includes(t)) score += 30;
      else if (it.labelNorm.split(/\s+/).some((w) => levenshtein(t, w, 2) <= (t.length >= 8 ? 2 : 1) && t.length >= 5)) score += 40;
    }
    if (!alles) continue;
    if (it.soort === "onderdeel") score -= 5;
    uit.push({ ...it, score });
  }
  uit.sort((a, b) => b.score - a.score || a.label.localeCompare(b.label, "nl"));
  return uit.slice(0, max);
}

const RECENT_SLEUTEL = "bpt_menu_recent";
export function leesRecent(index) {
  try {
    const tos = JSON.parse(localStorage.getItem(RECENT_SLEUTEL) || "[]");
    return tos.map((to) => index.find((it) => it.to === to)).filter(Boolean).slice(0, 5);
  } catch { return []; }
}
export function onthoudRecent(to) {
  try {
    const tos = JSON.parse(localStorage.getItem(RECENT_SLEUTEL) || "[]").filter((t) => t !== to);
    localStorage.setItem(RECENT_SLEUTEL, JSON.stringify([to, ...tos].slice(0, 5)));
  } catch { /* opslag niet beschikbaar */ }
}
